export const Modal = ({ children, title, onClose }) => {
    return (
        <div className="w-full h-full bg-black/30 backdrop-blur-sm overflow-hidden fixed top-0 left-0 z-50 flex items-center justify-center">
            <div className="w-[340px] bg-white border border-slate-200 rounded flex  shadow-sm items-center flex-col">
                <div className="w-full p-3 px-4 flex flex-row justify-between items-cente border-b border-b-slate-200">
                    <p>{title}</p>
                    <button
                        onClick={() => onClose(false)}
                        className="flex items-center justify-center">
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>
                {children}
            </div>
        </div>
    );
};

export const ModalBody = ({ children }) => {
    return (
        <div className="flex flex-col items-center gap-1 w-full p-3">
            {children}
        </div>
    );
};
export const Modalfooter = ({ children }) => {
    return (
        <div className="flex flex-col items-center gap-1 w-full p-3 mt-3 border-t border-t-slate-200">
            {children}
        </div>
    );
};
